var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgColorTeal = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 256 256",
  ref: ref
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h256v256.003H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M250.985 128.001c0 67.922-55.062 122.984-122.984 122.984-67.925 0-122.987-55.062-122.987-122.984S60.076 5.017 128.001 5.017c67.922 0 122.984 55.062 122.984 122.984"
}), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#009696",
  d: "M127.999 10.03c-65.048 0-117.97 52.922-117.97 117.97 0 65.051 52.922 117.972 117.97 117.972S245.969 193.051 245.969 128c0-65.048-52.922-117.97-117.97-117.97m0 245.974C57.419 256.004 0 198.582 0 128 0 57.42 57.42 0 127.999 0 198.579-.001 256 57.42 256 128c0 70.582-57.42 128.004-128 128.004",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009696",
  d: "M80.326 108.647l-10.9 1.27v51.147l-25.799 3.179 1.363-51.872-11.991 1.181.635-22.345 49.054-4.181z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#502D1B",
  d: "M45.67 111.64l-1.362 51.852 24.455-3.012v-51.15l10.963-1.279 2.216-20.299-47.664 4.062-.596 21.007 11.988-1.18zm-2.725 53.353l1.363-51.888-11.992 1.18.674-23.688L83.433 86.3l-2.507 22.944-10.84 1.264v51.141l-27.141 3.344z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009696",
  d: "M89.003 113.48l35.1-2.607-1.971 16.09-15.961.698-.063 3.051 11.574-.825-1.336 11.126-10.621.826-.126 3.5 18.187-1.717-.318 17.551-34.019 1.843z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#502D1B",
  d: "M89.67 114.093l.433 48.225 32.715-1.773.293-16.196-18.199 1.72.175-4.843 10.667-.83 1.176-9.791-11.499.817.092-4.397 16.022-.7 1.804-14.732-33.68 2.5zm-.876 49.621l-.459-50.848 36.522-2.713-2.136 17.445-15.9.696-.037 1.71 11.65-.835-1.497 12.462-10.572.822-.078 2.155 18.172-1.714-.342 18.907-35.323 1.913z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009696",
  d: "M150.619 145.02l7.568-1.336-3.179-8.647-4.39 9.983zm3.244-37.835l32.111 48.835-19.964 7.568-5.342-8.902-13.354.446-2.607 9.538-19.142-6.232 28.298-51.253z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#502D1B",
  d: "M154.952 136.806l-3.23 7.347 5.573-.982-2.343-6.365zm-5.436 9.08l5.546-12.618 4.018 10.931-9.564 1.688zm-22.986 12.172l17.721 5.768 2.554-9.338 14.23-.475 5.256 8.761 18.677-7.08-31.056-47.23-27.382 49.594zm18.63 7.454l-20.56-6.693 29.213-52.912 33.168 50.441-21.255 8.056-5.427-9.043-12.476.415-2.662 9.736z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009696",
  d: "M189.661 112.971l19.143-2.672-1.654 35.801 15.578-3.242.763 17.869-33.383 3.371z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#502D1B",
  d: "M190.327 113.546l.436 49.82 32.043-3.232-.706-16.47-15.652 3.259 1.656-35.857-17.777 2.48zm-.876 51.282l-.004-.725-.451-51.709 20.505-2.859-1.65 35.744 15.503-3.225.825 19.268-34.728 3.506z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgColorTeal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/color-teal.e52efd543ab4fc338c13d4c6b5304561.svg";